<script>
import api from "@/axios";
import Swal from "sweetalert2";
import moment from "moment/moment";
import Loader from "@/router/views_mobagile/components/loader.vue";
import Multiselect from "@vueform/multiselect";
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
    components: { Loader, Multiselect },
   data() {
     return {
        title: "Editar OS de Saída",
        items: [
            {
            text: "Ordens de Serviço",
            href: "/wmsossaida/list",
            },
            {
            text: "Editar OS de Saída",
            active: true
            }
        ],
        itenswmsos: {},
        idData: 0,
        updating: true,
        updatingListas: false,
        wmsOsListData: null,
        wmsOsData: {
            id: 0,
            status: "EL",
            formapgto: '10',
            condpgto: '10',
            fornec: '23',
            tipo: '06',
            dtemissao: new Date
        },
        clienteData: {},
        movData: {},
        wmsOsItemData: {},
        wmsOsItensData: {},
        wmsOsItensSepData: {},
        wmsOsItensSepPendData: [],
        wmsOsVolumesData: {},
        wmsOsVolumeData: {},
        wmsositemLotes: [],
        dtListLotes: [],
        itemResetLote: {
            endwms: "-",
            lote: "-",
        },
        totais: {
            lidos: 0,
            pendentes: 0,
        },
        produtobipado: null,
        dtListLoteProdAtual: [],
        wmsosItemAtualConferencia: {},
        idItemConferenciaAtual: 0,
        flagApresentarColunasLote: false,
        bgProdutoConferenciaAtual: "",
        bipConfirmado: true,
        listaLoteCompletaItemAtual: [],
        listaLoteToShow: [
                {
                endwms: "-",
                lote: "-",
                saldo: 0,
            }
        ],
        originalLotesEstoque: [],
        wmsOsItensDataConferidos: [],
        showModalVolume: false,
        showAssocRoma: false,
        loadingWmsVolume: false,
        somaPesoVolumes: 0,
        somaQtdVolumes: 0,
        dtListPesqRoma: [],
     };
   },
   mounted() {
    let rota = this.$route.path

    let ultimaBarra = rota.lastIndexOf('/')
    if (ultimaBarra) {
      this.idData = parseInt(rota.substring(ultimaBarra + 1))
    }
    console.log(`idData: ${this.idData}`)

    if (this.idData > 0) {
      this.carregarDados()

    } else {
      console.log('new wmsos...')

      this.title = `Iniciando Nova OS`
      this.updating = false
    }
   },

   watch: {
    wmsOsItensData: {
        handler() {
        
    },
        deep: true,
        immediate: true
    }
   },

   methods: {
    voltarListaWmsos(){
      this.$router.replace("/wmsossaida/list")
    },

    pesqRomaneio(evt) {
      console.log('pesqRomaneio')
      console.log(evt)
      let query = evt
      if (query.length > 1) {
        api.get(`${getBaseUrl()}api/wmsromapesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.dtListPesqRoma = res.data
        });
      }
    },

    confirmarAssocRoma() {
      console.log('associarRomaneio')
      // console.log(this.wmsosList)

      let idsAssoc = []
      idsAssoc.push(this.idData)


      api.post(`${getBaseUrl()}api/wmsromawmsos`, {
        idRoma: this.wmsOsData.wmsroma_id,
        idsData: idsAssoc
      }).then((res) => {
        console.log('then axios')
        console.log(res)
        // this.produtoData = res.data[0]
        // this.loadingList = false
        this.showAssocRoma = false

        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Informações salvas com sucesso!",
          showConfirmButton: false,
          timer: 1500
        })
        //this.atualizaDataList()
      })
    },

    associarRomaneio() {
      console.log('associarRomaneio')
      if (this.wmsOsData.origem2 === 'romaneio') {
        this.$router.push(`/wmsos/saidaromaeditar/${this.idData}`)
      } else {
        this.showAssocRoma = true
      }
    },

    confirmarVolume() {
      console.log('confirmarVolume')
      if (this.wmsOsVolumeData.qtd > 0 && this.wmsOsVolumeData.peso > 0) {
        this.loadingWmsVolume = true
        // this.loadingWmsEnder = true
        // console.log(this.wmsOsItemSepData.produto)
        api.post(`${getBaseUrl()}api/wmsosconfvol`, {
          'idwmsos': this.idData,
          'qtd': this.wmsOsVolumeData.qtd,
          'peso': this.wmsOsVolumeData.peso,
        }).then((res) => {
          console.log('then axios conf_vol')
          console.log(res.data)
          this.wmsOsVolumesData = res.data[0]
          let totalVols = 0
          let pesoVols = 0
          this.wmsOsVolumesData.forEach((value) => {
            totalVols += value.qtd
            pesoVols += value.peso
          });
          this.somaQtdVolumes = totalVols
          this.somaPesoVolumes = pesoVols
          this.loadingWmsVolume = false
          this.wmsOsVolumeData = {}
          this.$refs.qtdvolume.focus()
        }).then(() => {
            this.carregarDados()
        })
      }
    },

    finalizarParcial(){
      console.log('finalizarParcial...')

      Swal.fire({
        position: "center",
        icon: 'info',
        title: 'Finalizar parcialmente?',
        text: 'Uma nova ordem de saída baseada no orçamento será necessária posteriormente!',
        showCancelButton: true,
        showConfirmButton: true
      }).then((value) => {
        console.log(value)
        if(value.isConfirmed){
          this.salvar()
        }
      }).then(() => {
        api.post(`${getBaseUrl()}api/wmsosfinalparcialnew`, {
            'idwmsos': this.idData
          }).then((res) => {
            console.log('then axios finalizarParcial')
            console.log(res.data)

            let flag = res.data.success ?? false

            if(flag){
              Swal.fire({
                icon: 'success',
                position: 'top-end',
                showCancelButton: false,
                showConfirmButton: false,
                title: 'Redirecionando para o pedido gerado!',
                timer: 1500
              }).then(() => {
                this.$router.push(`/pedido/detalhe/${res.data.pedido_id}`)
              })
            }else{
              Swal.fire({
                icon: 'error',
                position: 'top-end',
                showCancelButton: false,
                showConfirmButton: false,
                text: res.data.message,
                timer: 3000
              })
            }
          }).catch((e) => {
            console.log('error...')
            console.log(e)
          })
      })
    },

    especificouLote(loteData) {
        console.log('especificouLote')
        console.log(`loteData: ${JSON.stringify(loteData)}`)

        this.baixaQtdProduto(loteData)
    },

    preencheInputProdutoBipado: async function() {
        console.log('preencheInputProdutoBipado')
        this.updating = true

        this.wmsosItemAtualConferencia = this.wmsOsItensData.find(item => {
            return (
                item.produto === this.produtobipado ||
                item.codbarra === this.produtobipado ||
                item.produto_id == this.produtobipado
            )
        });

        this.reordenarListaItens()

        try {
            await this.buscaDadosProdutoAtual(true)

            if (this.bipConfirmado) {
                this.bipouProduto()
            } else {
                this.$refs.produto.focus()
            }
        } catch (error) {
            console.error('Erro ao buscar dados do produto:', error);

            Swal.fire({
                position: "center",
                icon: "error",
                title: "Erro ao buscar dados do produto.",
                text: "Por favor, verifique o código ou EAN digitado.",
                showConfirmButton: false,
                timer: 2500
            });

            this.$refs.produto.focus()
        }
        this.updating = false
    },
    
    preencheInputProduto: async function (codigo) {
        
        console.log('preencheInputProduto')
         this.wmsosItemAtualConferencia = this.wmsOsItensData.find(item => {
            return (
                item.produto === codigo ||
                item.codbarra === codigo ||
                item.produto_id === codigo
            )
        });
        //console.log(`wmsosItemAtualConferencia: ${JSON.stringify(this.wmsosItemAtualConferencia)}`)

        this.reordenarListaItens()

        this.produtobipado = codigo

        this.idItemConferenciaAtual = this.wmsosItemAtualConferencia.id

        try {
            await this.buscaDadosProdutoAtual(false)

            this.$refs.produto.focus()
        } catch (error) {
            console.error('Erro ao buscar dados do produto:', error);

            Swal.fire({
                position: "center",
                icon: "error",
                title: "Erro ao buscar dados do produto.",
                text: "Por favor, verifique o código ou EAN digitado.",
                showConfirmButton: false,
                timer: 2500
            });

            this.$refs.produto.focus()
        }   
    },

    bipouProduto() {
        console.log('bipouProduto');

        this.baixaQtdProduto(null)
        this.updating = false
    },

    buscaDadosProdutoAtual: function (skipBipCall) {
        console.log('buscaDadosProdutoAtual');
        this.bgProdutoConferenciaAtual = "";

        return api.get(`${getBaseUrl()}api/pesqproddadossep`, {
            params: {
                produto: this.produtobipado,
                empresa: this.wmsOsData.empresa
            }
        }).then((res) => {
            console.log('then axios /pesqproddadossep');
            console.log(JSON.stringify(res.data));

            let fetchedLotes = JSON.parse(JSON.stringify(res.data.produtosaldoloc));

            fetchedLotes.forEach(loteAPI => {
                const deduceQuantity = (item, sourceCollectionName) => {
                    if (item.produto_id === loteAPI.produto_id && item.lote && item.lote.length > 0) {
                        item.lote.forEach(loteItem => {
                            if (loteItem.lote === loteAPI.lote) {
                                loteAPI.saldo -= loteItem.qtd;
                                console.log(`Dedução: Lote ${loteAPI.lote} do produto ${loteAPI.produto_id} deduzido em ${loteItem.qtd} da coleção ${sourceCollectionName}. Novo saldo: ${loteAPI.saldo}`);
                            }
                        });
                    }
                };

                this.wmsOsItensData.forEach(item => deduceQuantity(item, 'wmsOsItensData'));

                this.wmsOsItensDataConferidos.forEach(item => deduceQuantity(item, 'wmsOsItensDataConferidos'));
            });

            this.dtListLoteProdAtual = fetchedLotes.filter(lote => lote.saldo > 0);
            
            this.listaLoteToShow = JSON.parse(JSON.stringify(this.dtListLoteProdAtual)); 
            
            this.listaLoteCompletaItemAtual = res.data.produtosaldoloc.filter(loteProd => {
                return !this.wmsOsItensData.some(item =>
                    item.produto_id === loteProd.produto_id &&
                    item.lote && item.lote.some(l => l.lote === loteProd.lote && l.qtd >= loteProd.saldo)
                );
            });

            if((this.dtListLoteProdAtual && this.dtListLoteProdAtual.length === 1) && skipBipCall) {
                console.log('entrou no if errado')
                this.baixaQtdProduto(this.dtListLoteProdAtual[0])
            }else if (this.dtListLoteProdAtual && this.dtListLoteProdAtual.length > 1) {
                console.log('Mais de um lote encontrado!');

                this.bipConfirmado = false;
                this.bgProdutoConferenciaAtual = "custom-warning-bg";
                Swal.fire({
                    position: "center",
                    icon: "warning",
                    title: "Mais de um lote encontrado, selecione o lote desejado.",
                    showConfirmButton: true,
                    confirmButtonText: "Confirmar"
                });
            }

            this.$refs.produto.focus()

            return;
        })
        .catch(error => {
            console.error('Erro na requisição /pesqproddadossep:', error);
            this.bipConfirmado = false;
            this.bgProdutoConferenciaAtual = "custom-danger-bg";
            Swal.fire({
                position: "center",
                icon: "error",
                title: "Erro na comunicação com o servidor.",
                text: "Não foi possível buscar dados do produto. Tente novamente.",
                showConfirmButton: false,
                timer: 3000
            });
            throw error;
        });
    },

    baixaQtdProduto(lote) {
        console.log('baixaQtdProduto')
        //console.log(`dtListLoteProdAtual: ${JSON.stringify(this.dtListLoteProdAtual)}`)

        let itemFinalizado = null

        this.wmsOsItensData.forEach(item => {
            if (
                item.produto_id === this.wmsosItemAtualConferencia.produto_id ||
                item.produto === this.wmsosItemAtualConferencia.produto ||
                item.codbarra === this.wmsosItemAtualConferencia.codbarra
            ) {
                console.log(`item finded: ${JSON.stringify(item)}`)
                
                item.qtdlida = this.roundToDecimal(parseFloat(item.qtdlida || 0), 4)
                item.qtd = this.roundToDecimal(parseFloat(item.qtd || 0), 4)

                if (item.qtdlida >= item.qtd || item.qtlida === 0) {
                    Swal.fire({
                        position: "top-end",
                        icon: "warning",
                        title: "Item atual foi conferido!",
                        showCancelButton: false,
                        showConfirmButton: false,
                        timer: 2500
                    })
                    return
                }

                let qtdBaixa = 1
                if (this.wmsosItemAtualConferencia.composicao && this.wmsosItemAtualConferencia.composicao.length > 0) {
                    console.log('produto contém composição')
                    qtdBaixa = this.wmsosItemAtualConferencia.composicao[0].qtd
                    /**
                     * Convertendo valor para numérico
                     */
                    qtdBaixa = parseFloat(qtdBaixa)
                }

                console.log(`qtd lida: ${qtdBaixa}(${typeof qtdBaixa})`)

                if (item.composicao) {
                    item.qtdlida += this.roundToDecimal(qtdBaixa, 4)
                    item.qtddisp -= this.roundToDecimal(qtdBaixa, 4)
                } else {
                    item.qtdlida += qtdBaixa
                    item.qtddisp -= qtdBaixa
                }

                if (!Array.isArray(item.lote)) {
                    item.lote = [];
                }
                if (!Array.isArray(item.endwms)) {
                    item.endwms = [];
                }

                let loteToAdd = null
                let endwmsToAdd = null

                if (lote) {
                    loteToAdd = {
                        lote: lote.lote,
                        qtd: qtdBaixa
                    }
                    endwmsToAdd = lote.endwms;
                } else if (this.dtListLoteProdAtual && this.dtListLoteProdAtual.length > 0) {
                    loteToAdd = {
                        lote: this.dtListLoteProdAtual[0]?.lote,
                        qtd: qtdBaixa
                    }
                    endwmsToAdd = this.dtListLoteProdAtual[0]?.endwms;
                }

                if (loteToAdd) {
                    const existingLoteIndex = item.lote.findIndex(l => l.lote === loteToAdd.lote);

                    if (existingLoteIndex > -1) {
                        item.lote[existingLoteIndex].qtd += this.roundToDecimal(qtdBaixa, 4)
                    } else {
                        item.lote.push({ lote: loteToAdd.lote, qtd: this.roundToDecimal(qtdBaixa, 4) })
                    }
                    this.flagApresentarColunasLote = true;
                }

                // Modificação para evitar endwms repetido
                if (endwmsToAdd) { // Verifica se há um endwms para adicionar
                    const existingLoteEndwms = item.endwms.some(e => e.lote === loteToAdd.lote && e.endwms === endwmsToAdd);

                    if (!existingLoteEndwms) {
                        item.endwms.push({ lote: loteToAdd.lote, endwms: endwmsToAdd });
                        this.flagApresentarColunasLote = true;
                    }
                }

                if (item.qtddisp <= 0 || item.qtd === item.qtdlida) {
                    this.wmsOsItensDataConferidos.push(item)
                    itemFinalizado = item
                }
                
                console.log(`item updated: ${JSON.stringify(item)}`)
            }
        })

        if(itemFinalizado) {
            this.wmsOsItensData = this.wmsOsItensData.filter(item => item.id !== itemFinalizado.id)
            this.updating = false
            this.salvar()
        }

        /**
         * Fechando baixa do item atual
         */
        this.totalizaWmsos()
        this.resetBipState()

        console.log(`actual wmsOsItensData: ${JSON.stringify(this.wmsOsItensData)}`)
        console.log(`actual wmsOsItensDataConferidos: ${JSON.stringify(this.wmsOsItensDataConferidos)}`)

        if (this.totais.pendentes === 0) {
            Swal.fire({
                position: "center",
                icon: "success",
                title: "Finalizando conferência",
                showCancelButton: false,
                showConfirmButton: false,
                timer: 2500
            }).then(() => {
                this.salvar()
            }).then(() => {
                this.finalizaConferencia()
            })
        }
    },

    reordenarListaItens: function() {
        console.log('reordenarListaItens');

        if (!this.wmsosItemAtualConferencia || !this.wmsOsItensData || this.wmsOsItensData.length === 0) {
            return;
        }

        const itemParaMover = this.wmsosItemAtualConferencia;
        const listaAtual = [...this.wmsOsItensData];

        const index = listaAtual.findIndex(item => item.id === itemParaMover.id);

        if (index > -1) {
            listaAtual.splice(index, 1);
            listaAtual.unshift(itemParaMover);

            this.wmsOsItensData = listaAtual;
        }
    },

    roundToDecimal(num, decimalPlaces) {
      const factor = Math.pow(10, decimalPlaces);
      return Math.round(num * factor) / factor;
    },

    atualizaSaldosLotesConferidos: function () {
        console.log('Iniciando atualizaSaldosLotesConferidos');

        const colecoesParaAtualizar = [
            this.dtListLoteProdAtual,
            this.listaLoteToShow,
            this.listaLoteCompletaItemAtual
        ];

        this.wmsOsItensData.forEach(osItem => {
            if (osItem.lote && Array.isArray(osItem.lote) && osItem.lote.length > 0) {
                osItem.lote.forEach(loteConferido => {
                    const loteId = loteConferido.lote;
                    const qtdLida = loteConferido.qtd;
                    const produtoIdDoItemOS = osItem.produto_id;

                    console.log(`Processando lote conferido: ${loteId} (Produto ID: ${produtoIdDoItemOS}, Qtd Lida: ${qtdLida})`);

                    colecoesParaAtualizar.forEach(colecao => {
                        if (!colecao) return; 

                        const indexLoteNaColecao = colecao.findIndex(loteEstoque =>
                            loteEstoque.produto_id === produtoIdDoItemOS &&
                            loteEstoque.lote === loteId
                        );

                        if (indexLoteNaColecao !== -1) {
                            let loteEstoque = colecao[indexLoteNaColecao];
                            console.log(`Lote '${loteId}' encontrado na coleção. Saldo anterior: ${loteEstoque.saldo}`);

                            loteEstoque.saldo -= qtdLida;

                            console.log(`Novo saldo para lote '${loteId}': ${loteEstoque.saldo}`);

                            if (loteEstoque.saldo <= 0) {
                                colecao.splice(indexLoteNaColecao, 1);
                                console.log(`Lote '${loteId}' removido da coleção (saldo <= 0).`);
                            }
                        } else {
                            console.log(`Lote '${loteId}' (Produto ID: ${produtoIdDoItemOS}) não encontrado nesta coleção.`);
                        }
                    });
                });
            }
        });

        //console.log('Finalizando atualizaSaldosLotesConferidos');
        //console.log(`dtListLoteProdAtual após atualização: ${JSON.stringify(this.dtListLoteProdAtual)}`);
        //console.log(`listaLoteToShow após atualização: ${JSON.stringify(this.listaLoteToShow)}`);
        //console.log(`listaLoteCompletaItemAtual após atualização: ${JSON.stringify(this.listaLoteCompletaItemAtual)}`);
    },

    getRowClass(data) {
        if (data.id === this.idItemConferenciaAtual) {
            //console.log(`Applying bg-info to id: ${data.id}`);
            return "bg-info";
        }

        if (data.qtddisp === 0) {
            //console.log(`Applying bg-success to id: ${data.id}`);
            return "bg-success";
        }

        return ""
    },


    resetBipState() {
        console.log('resetBipState')

        this.dtListLoteProdAtual = [];
        //this.listaLoteToShow = [{ endwms: "-", lote: "-", saldo: 0 }];
        this.produtobipado = null;
        this.bgProdutoConferenciaAtual = "";
        this.updating = false;
        this.bipConfirmado = true;
        this.idItemConferenciaAtual = 0;
        this.listaLoteToShow = [
                {
                endwms: "-",
                lote: "-",
                saldo: 0,
            }
        ]

        this.$nextTick(() => {
            this.$refs.produto.focus();
        });
    },

    totalizaWmsos() {
        this.totais.lidos = this.wmsOsItensData
            .map(item => parseFloat(item.qtdlida || 0))
            .reduce((acc, val) => acc + val, 0);

        if (this.wmsOsItensDataConferidos && this.wmsOsItensDataConferidos.length > 0) {
            const lidosConferidos = this.wmsOsItensDataConferidos
                .map(item => parseFloat(item.qtdlida || 0))
                .reduce((acc, val) => acc + val, 0);
            this.totais.lidos += lidosConferidos;
        }

        let totalOriginal = this.wmsOsItensData
            .map(item => parseFloat(item.qtd || 0))
            .reduce((acc, val) => acc + val, 0);

        if (this.wmsOsItensDataConferidos && this.wmsOsItensDataConferidos.length > 0) {
            const originalConferidos = this.wmsOsItensDataConferidos
                .map(item => parseFloat(item.qtd || 0))
                .reduce((acc, val) => acc + val, 0);
            totalOriginal += originalConferidos;
        }

        this.totais.disponiveis = this.wmsOsItensData
            .map(item => parseFloat(item.qtddisp || 0))
            .reduce((acc, val) => acc + val, 0);

        if (this.wmsOsItensDataConferidos && this.wmsOsItensDataConferidos.length > 0) {
            const disponiveisConferidos = this.wmsOsItensDataConferidos
                .map(item => parseFloat(item.qtddisp || 0))
                .reduce((acc, val) => acc + val, 0);
            this.totais.disponiveis += disponiveisConferidos;
        }

        this.totais.pendentes = totalOriginal - this.totais.lidos;
    },

    finalizaConferencia() {
        api.post(`${getBaseUrl()}api/wmsositconfseptransp`, {
            'idwmsos': this.wmsOsData.id ?? this.idData,
            'autoImpressao': this.autoImpressao
          }).then((res) => {
            console.log('then axios separar2_2')
            console.log(res.data)
            
            this.carregarDados()
          }).then(() => {
            this.resetBipState()
          })
    },

    separarTodos(){
      console.log('separarTodos')

      Swal.fire({
        position: "center",
        icon: "question",
        title: "Separar Todos Itens",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
            console.log(result.value)
            console.log('vai')
                
            this.updating = true
            api.post(`${getBaseUrl()}api/wmsosseptodos`, {
                'iddata': this.idData
            }).then((res) => {
                console.log('then axios separar2_1')
                console.log(res.data)

                let flag = res.data.success ?? false

                this.updating = false
                if(flag){
                Swal.fire({
                    icon: 'success',
                    position: 'top-end',
                    showCancelButton: false,
                    showConfirmButton: false,
                    title: 'Redirecionando para o pedido gerado!',
                    timer: 1500
                }).then(() => {
                    this.$router.push(`/pedido/detalhe/${res.data.pedido_id}`)
                })
                }else{
                Swal.fire({
                    icon: 'error',
                    position: 'top-end',
                    showCancelButton: false,
                    showConfirmButton: false,
                    text: res.data.message,
                    timer: 3000
                })
                }
            }).catch((e) => {
                console.log('error...')
                console.log(e)
            })
        }
      })
    },

    excluir() {
      console.log('excluir')
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Excluir Ordem",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          api.delete(`${getBaseUrl()}api/wmsos`, {
            params: {
              'iddata': this.idData
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)

              if(res.data.redirecionaEstoque){
              Swal.fire({
                position: "center",
                icon: "warning",
                title: "Saldo bloqueado!",
                text: "Deseja redirecionar-se transferência de saldos?",
                showConfirmButton: true,
                showCancelButton: true,
                confirmButtonText: "Sim",
                cancelButtonText: "Não",
              }).then((check) => {
                if(check.isConfirmed){
                  this.$router.push('/produtos/listestoque')
                }else{
                  this.$router.push('/wmsossaida/list')
                }
              })
            }else{
              if(res.data.success){
                Swal.fire({
                  position: "top-end",
                  icon: "success",
                  title: res.data.message,
                  showConfirmButton: false,
                  timer: 1500
                }).then(() => {
                  this.$router.replace('/wmsossaida/list')
                })
              }else{
                Swal.fire({
                  position: "top-end",
                  icon: "error",
                  title: res.data.message,
                  showConfirmButton: false,
                  timer: 1500
                })
              }
            }
          })
        }
      })
    },

    filtrarDisponiveis(arrayEntr) {
      //this.wmsOsItensData = res.data[6]
      console.log('filtrarDisponiveis')
      let listaFiltrada = []
      arrayEntr.forEach((value) => {
        if (value.qtddisp > 0) {
          listaFiltrada.push(value)
        }

        if(value.lote.length > 0) [
            this.flagApresentarColunasLote = true
        ]
      });
      return listaFiltrada
    },

    salvar(){
      console.log('efetivarSepPend')

      if(!this.updating) {
        Swal.fire({
            position: "top-end",
            icon: "info",
            title: "Salvando informações!",
            showCancelButton: false,
            showConfirmButton: false,
            timer: 1500
        })

        this.updatingListas = true
        api.post(`${getBaseUrl()}api/wmsossalvarsaida`, {
            'wmsos': this.wmsOsData,
            'wmsositensConferidos': this.wmsOsItensDataConferidos,
            'wmsositens': this.wmsOsItensData,
            'idwmsos': this.idData
        }).then((res) => {
            console.log('then axios separarPend')
            console.log(JSON.stringify(res.data))

            if(res.data.success) {
                Swal.fire({
                    position: "top-end",
                    icon: "success",
                    title: res.data.message,
                    showCancelButton: false,
                    showConfirmButton: false,
                    timer: 1500
                })
            } else {
                Swal.fire({
                    position: "top-end",
                    icon: "error",
                    title: res.data.error,
                    showCancelButton: false,
                    showConfirmButton: false,
                    timer: 2500
                })
            }

            this.carregarDados()
        })
      }else{
        Swal.fire({
            position: "center",
            icon: "warning",
            title: "Atualização de dados em andamento!",
            showCancelButton: false,
            showConfirmButton: false,
            timer: 2500
          })
      }
    },

    agruparLotesEEndwms(data) {
        return data.map(item => {
            const lotesAgrupados = {};
            item.lote.forEach(l => {
            if (lotesAgrupados[l.lote]) {
                lotesAgrupados[l.lote].qtd += l.qtd;
            } else {
                lotesAgrupados[l.lote] = { ...l };
            }
            });
            item.lote = Object.values(lotesAgrupados);

            const endwmsAgrupados = {};
            item.endwms.forEach(e => {
            const key = `${e.lote}-${e.endwms}`; 
            if (!endwmsAgrupados[key]) {
                endwmsAgrupados[key] = { ...e };
            }
            });
            item.endwms = Object.values(endwmsAgrupados);

            return item;
        });
    },

    carregarDados() {
      this.updating = true
      api.get(`${getBaseUrl()}api/wmsossaida`, {
        params: {
          iddata: this.idData,
          newPage: true
        }
      }).then((res) => {
        console.log('then axios wmsosEditar')
        console.log(res.data)
        this.wmsOsData = res.data[0]
        this.wmsOsListData = res.data[4]
        this.wmsOsVolumesData = res.data[1]
        // this.transpData = res.data[2]
        this.clienteData = res.data[3]
        this.movData = res.data[5]

        this.flagProdutoSaldoWmsos = res.data[10]
        //console.log(`flagProdutoSaldoWmsos: ${this.flagProdutoSaldoWmsos}`)

        /**
         * Validando que não possui produto_id duplicado
         */
        const uniqueItems = Array.from(new Map(res.data[6].map(item => [item.id, item])).values())
        //console.log(`uniqueItems: ${JSON.stringify(uniqueItems)}`)

        this.wmsOsItensData = this.agruparLotesEEndwms(this.filtrarDisponiveis(uniqueItems))
        //console.log(`carregarDados wmsOsItensData: ${JSON.stringify(this.wmsOsItensData)}`)

        this.wmsOsItensDataConferidos = uniqueItems.filter(uniqueItem =>
            !this.wmsOsItensData.some(wmsItem => wmsItem.id === uniqueItem.id)
        )
        this.wmsOsItensDataConferidos = this.agruparLotesEEndwms(this.wmsOsItensDataConferidos)

        this.itenswmsos = uniqueItems
        this.wmsOsItensSepData = res.data[7]
        //console.log(`itens separados: ${JSON.stringify(res.data[7])}`)

        
        this.tipoConferencia = this.flagProdutoSaldoWmsos ? 'M' : 'A'

        this.empresaData = res.data[8]
        this.wmsOsDuplicadaData = res.data[9]
        if (this.wmsOsDuplicadaData && this.wmsOsDuplicadaData.id) {
          Swal.fire({
            position: "top-end",
            icon: "warning",
            title: "Ordem de serviço em duplicidade, excluir esta ou a id: " + this.wmsOsDuplicadaData.id + " antes de continuar.",
            showCancelButton: false,
            showConfirmButton: false,
            timer: 2500
          })
        }


        if (this.wmsOsItensData.length > 0) {
          this.wmsOsItensData.forEach((value) => {
            if (value.imgs) {
              let imgTrat = value.imgs.split(',')
              value.img1 = `${getBaseUrl()}/uploads/imgprods/peq/${imgTrat[0]}`
            }
          })
        }

        /***
        * verificando se possui composição
        */
        this.flagConferenciaCompos = res.data[11]
        console.log(`flagConferenciaCompos: ${this.flagConferenciaCompos}`)

        if (this.wmsOsItensSepData.length > 0) {
          this.wmsOsItensSepData.forEach((value) => {
            if (value.imgs) {
              let imgTrat = value.imgs.split(',')
              value.img1 = `${getBaseUrl()}/uploads/imgprods/peq/${imgTrat[0]}`
            }
          })
        }


        this.idData = this.wmsOsData.id
        this.title = `Editar OS de Saída (${this.wmsOsData.id}) ${this.clienteData != null ? this.clienteData.cidade + '/' + this.clienteData.estado : ''}`
        this.updating = false
        
        //Totalizando dados
        this.totalizaWmsos()
        this.resetBipState()

      }).then(() => {
        setTimeout(() => {
          this.$refs.produto.focus()
        }, 500)
      })
    },

    reiniciar() {
      console.log('reiniciar')

      Swal.fire({
        position: "center",
        icon: "question",
        title: "Reiniciar Conferência",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          console.log('reiniciando wmsos')
          this.wmsOsItemData['idwmsos'] = this.idData
          this.updatingListas = true

          api.post(`${getBaseUrl()}api/wmsosreinicia`, {
            'iddata': this.idData
          }).then((res) => {
            console.log('then axios separar2_1')
            console.log(res.data)
            
            this.resetBipState()
            this.carregarDados()

            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Comando Reiniciar executado com sucesso!",
              showConfirmButton: false,
              timer: 1500
            }).then(() => {
              this.carregarDados()
            })
          })
        }
      })

    },

    formatDecimal(value) {
        if (value === null || value === undefined || value === "") {
            return "0,00"; // Ou "0" se preferir para valores nulos/vazios
        }

        let value_n = parseFloat(value);

        if (isNaN(value_n)) {
            return "0,00";
        }

        if (Number.isInteger(value_n)) {
            return value_n.toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
        } else {
            return value_n.toLocaleString('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 4 });
        }
    },

    formatInteger(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if (value) {
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', { style: 'decimal', minimumFractionDigits: 0 });
      }
      return 0.00;
    },

    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

    formatDate(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

    nomeStatus(stsIn){
      let result = 'Não Definido'
      switch (stsIn) {
        case 'AB':
          result = 'Aberto'
          break
        case 'CA':
          result = 'Cancelado'
          break
        case 'CF':
          result = 'Conferido'
          break
        case 'CO':
          result = 'Confirmado'
          break
        case 'EQ':
          result = 'Embarque'
          break
        case 'FN':
          result = 'Finalizado'
          break
        case 'SE':
          result = 'Conferido'
          break
      }
      return result
    },

    statusColor() {
        if(this.wmsOsData.status) {
            switch (this.wmsOsData.status) {
                case 'AB':
                    return 'badge-soft-warning';
                case 'CA':
                    return 'badge-soft-danger';
                case 'CF':
                    return 'badge-soft-success';
                case 'CO':
                    return 'badge-soft-info';
                case 'EQ':
                    return 'badge-soft-warning';
                case 'FN':
                    return 'badge-soft-success';
                case 'SE':
                    return 'badge-soft-success';
                default:
                    return 'badge-soft-info';
            }
        }
    },
   },
};
</script>


<template>
<!--    <b-modal
        v-model="updating"
        id="modal-loading"
        centered
        hide-footer
    >
    <h4>Carregando dados...</h4>
        <Loader v-if="updating" style="min-height: 400px;">
            </Loader>
    </b-modal>-->

  <div class="p-4 bg-light min-vh-100">
    <b-card class="mb-4 shadow-sm">
      <b-card-body class="d-flex flex-column align-items-center justify-content-center">
        <div class="d-flex flex-column flex-md-row align-items-center justify-content-center mb-2 text-center">
            <div class="h4 font-weight-bold text-dark mb-2 mb-md-0 me-md-4">
            OS DE SAÍDA ({{ idData }}) - <span :class="statusColor()">{{ nomeStatus(wmsOsData.status) }}</span>
            </div>
            <div class="h4 font-weight-bold text-dark mb-2 mb-md-0">
            Cliente: {{ `${clienteData.nome} - ${clienteData.cidade}/${clienteData.estado}` }} • {{ wmsOsData.origem === 'orcamento' ? 'Orçamento' : "NF-e" }}: {{ this.movData.numped ?? this.movData.codigo ?? this.movData.id }}
            </div>
        </div>

        <div class="d-flex gap-2 flex-wrap justify-content-center">
            <b-button variant="outline-info" class="back-button" @click="voltarListaWmsos">
              <i class="bx bx-arrow-back font-size-16 align-middle me-2"></i>
              Voltar
            </b-button>

            <b-button variant="outline-primary" class="mx-2" @click="salvar" :disable="wmsOsData.status !== 'AB'">
              <i class="bx bx-save font-size-16 align-middle me-2"></i>
              Salvar
            </b-button>

            <b-button :disabled="wmsOsData.status !== 'AB'" variant="outline-primary" class="mx-2" @click="associarRomaneio">
              <i class="bx bx-link font-size-16 align-middle-me-2"></i>
              Associar romaneio {{ wmsOsData.wmsroma_id }}
            </b-button>

            <b-button variant="outline-primary" class="mx-2" @click="showModalVolume = true">
              <i class="bx bx-box font-size-16 align-middle me-2"></i>
              Volumes (alt + V)
            </b-button>

            <b-button variant="outline-danger" class="mx-2" @click="reiniciar" v-show="(wmsOsData.status === 'ES' || wmsOsData.status === 'AB')">
              <i class="bx bx-trash font-size-16 align-middle me-2"></i>
              Excluir
            </b-button>

            <b-button variant="outline-primary" class="mx-2" @click="reiniciar" v-show="(wmsOsData.status === 'ES' || wmsOsData.status === 'AB')">
              <i class="bx bx-sync font-size-16 align-middle me-2"></i>
              Reiniciar
            </b-button>

            <b-button variant="outline-info" class="mx-2" @click="finalizarParcial" v-show="(wmsOsData.status === 'ES' || (wmsOsData.status === 'AB' && empresaData.geraped === 'OS'))">
              <i class="bx bx-sync font-size-16 align-middle me-2"></i>
              Finalizar Parcialmente
            </b-button>

            <b-button variant="outline-success" class="mx-2" @click="separarTodos" v-show="(wmsOsData.status === 'ES' || wmsOsData.status === 'AB')">
              <i class="bx bx-check font-size-16 align-middle me-2"></i>
              Conferir Todos
            </b-button>
        </div>

        <div class="row mt-5 mb-1 col-12 justify-content-center">
          <!--      <div class="col">-->
          <div class="card custom-card-green text-success-emphasis col-5 col-sm-5">
            <div class="card-body text-center h1 font-weight-bold  py-3">
              <h3 class="text-muted">Conferidos</h3>
              <span style="font-size: 60px">{{ formatDecimal(totais.lidos) }}</span>
            </div>
          </div>
          <!--        <b-card class="custom-card-green text-success-emphasis">
                    <b-card-body class="text-center h1 font-weight-bold  py-3">
                      <div>
                          <h3 class="text-muted">Conferidos</h3>
                          <span style="font-size: 60px">{{ formatDecimal(totais.lidos) }}</span>
                      </div>
                    </b-card-body>
                  </b-card>-->
          <!--      </div>-->
          <!--      <div class="col">-->
          <div class="card custom-card-red text-danger-emphasis col-5 col-sm-5 ms-2 ms-sm-5">
            <div class="card-body text-center h1 font-weight-bold  py-3">
              <h3 class="text-muted">Conferidos</h3>
              <span style="font-size: 60px">{{ formatDecimal(totais.pendentes) }}</span>
            </div>
          </div>
          <!--        <b-card class="custom-card-red text-danger-emphasis">
                    <b-card-body class="text-center h1 font-weight-bold py-3">
                      <div>
                          <h3 class="text-muted">Pendentes</h3>
                        <span style="font-size: 60px">{{ formatDecimal(totais.pendentes) }}</span>

                      </div>
                    </b-card-body>
                  </b-card>-->
          <!--      </div>-->
        </div>

        <div class="row mb-2">


              <h5 v-if="updating" class="text-center">Carregando dados...</h5>
              <Loader v-if="updating" style="min-height: 400px;">
              </Loader>

              <b-card-body v-if="!updating" class="row space-y-4 py-4">
                <div class="col-5 mb-2">
                  <label for="codigo-produto" class="form-label h4 font-weight-medium">
                    <i class="bx bx-barcode"></i> EAN|Código Produto
                  </label>

                  <b-form-input
                      id="codigo-produto"
                      class="form-control-lg py"
                      placeholder="Bipe o código ou EAN do produto..."
                      ref="produto"
                      @keypress.enter="bipouProduto"
                      v-model="produtobipado"
                  ></b-form-input>
                </div>

                <div class="col-6 ms-auto">
                  <div class="d-flex">
                    <h2>{{ wmsosItemAtualConferencia.descprod ?? "" }}</h2>
                  </div>

                  <div class="table-responsive">
                    <table class="table text-lg">
                      <thead>
                      <tr class="bg-light">
                        <th scope="col" class="p-2">Lote</th>
                        <th scope="col" class="p-2">Endereço WMS</th>
                        <th scope="col" class="p-2 text-center">Saldo</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="data in listaLoteToShow" :key="data.id" class="border-bottom bg-white">
                        <td class="p-2" style="cursor:pointer;" @click="especificouLote(data)">{{ data.lote ?? "-" }}</td>
                        <td class="p-2">{{ data.endwms?? "-" }}</td>
                        <td class="p-2 text-center">{{ data.saldo ? formatDecimal(data.saldo) : "-" }}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <hr class="mt-2 mb-4">

                <b-tabs pills justified content-class="p-3 text-muted">
                  <b-tab active>
                    <template v-slot:title>
                      <span class="d-none d-sm-inline-block">Pendentes</span>
                    </template>
                    <div class="table-responsive" style="max-height: 230px; overflow-y: auto;">
                      <table class="table table-striped table-hover text-lg">
                        <thead>
                        <tr class="bg-light">
                          <th scope="col" class="p-2">Produto</th>
                          <th scope="col" class="p-2">Descrição</th>
                          <th scope="col" class="p-2 text-center" v-if="flagApresentarColunasLote">Lote</th>
                          <th scope="col" class="p-2 text-center" v-if="flagApresentarColunasLote">Endereço</th>
                          <th scope="col" class="p-2 text-center">Total</th>
                          <th scope="col" class="p-2 text-center">Lido</th>
                          <th scope="col" class="p-2 text-center">Pendentes</th>
                          <th scope="col" class="p-2 text-center" colspan="2">Composição</th>
                        </tr>
                        <tr class="bg-light">
                          <th scope="col" class="p-2"></th>
                          <th scope="col" class="p-2"></th>
                          <th scope="col" class="p-2 text-center" v-if="flagApresentarColunasLote"></th>
                          <th scope="col" class="p-2 text-center" v-if="flagApresentarColunasLote"></th>
                          <th scope="col" class="p-2 text-center"></th>
                          <th scope="col" class="p-2 text-center"></th>
                          <th scope="col" class="p-2 text-center"></th>
                          <th scope="col" class="p-2 text-center">Fator</th>
                          <th scope="col" class="p-2 text-center">Valor</th>
                        </tr>
                        </thead>
                        <tbody>
                        <template v-for="data in wmsOsItensData" :key="data.id">
                          <tr class="border-bottom"> <td class="p-2" style="cursor:pointer;" @click="preencheInputProduto(data.produto)">{{ data.produto }}<span class="text-muted">(EAN:{{ data.codbarra }})</span></td>
                            <td class="p-2">{{ data.descprod }}</td>
                            <td class="p-2" v-if="flagApresentarColunasLote">
                              <table v-if="data.lote && data.lote.length > 0" class="table table-sm mb-0">
                                <thead>
                                <tr>
                                  <th>Lote</th>
                                  <th>Qtd</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(l, index) in data.lote" :key="index">
                                  <td>{{ l.lote }}</td>
                                  <td>{{ l.qtd }}</td>
                                </tr>
                                </tbody>
                              </table>
                              <span v-else>-</span>
                            </td>
                            <td class="p-2" v-if="flagApresentarColunasLote">
                              <table v-if="data.endwms && data.endwms.length > 0" class="table table-sm mb-0">
                                <thead>
                                <tr>
                                  <th>Lote</th>
                                  <th>Endereço</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(e, index) in data.endwms" :key="index">
                                  <td>{{ e.lote }}</td>
                                  <td>{{ e.endwms }}</td>
                                </tr>
                                </tbody>
                              </table>
                              <span v-else>-</span>
                            </td>
                            <td class="p-2 text-center">{{ formatDecimal(data.qtd) }}</td>
                            <td class="p-2 text-center text-success font-weight-bold"><h4 class="text-success">{{ formatDecimal(data.qtdlida) }}</h4></td>
                            <td class="p-2 text-center text-danger font-weight-bold"><h4 class="text-danger">{{ formatDecimal(data.qtddisp) }}</h4></td>
                            <td class="p-2 text-center">{{ data.composicao ? (data.composicao[0].fator === '/' ? "Divisão" : "Multiplicação") : "-" }}</td>
                            <td class="p-2 text-center">{{ data.composicao ? formatDecimal(data.composicao[0].qtd) : "-" }}</td>
                          </tr>
                        </template>
                        <template v-if="wmsOsItensData.length === 0">
                          <tr>
                            <td colspan="9"> <b-alert show variant="info" class="m-0">Nenhum item disponível.</b-alert>
                            </td>
                          </tr>
                        </template>
                        </tbody>
                      </table>
                    </div>
                  </b-tab>

                  <b-tab>
                    <template v-slot:title>
                      <span class="d-none d-sm-inline-block">Conferidos</span>
                    </template>
                    <div class="table-responsive" style="max-height: 230px; overflow-y: auto;">
                      <table class="table table-striped table-hover text-lg">
                        <thead>
                        <tr class="bg-light">
                          <th scope="col" class="p-2">Produto</th>
                          <th scope="col" class="p-2">Descrição</th>
                          <th scope="col" class="p-2 text-center" v-if="flagApresentarColunasLote">Lote</th>
                          <th scope="col" class="p-2 text-center" v-if="flagApresentarColunasLote">Endereço</th>
                          <th scope="col" class="p-2 text-center">Total</th>
                          <th scope="col" class="p-2 text-center">Lido</th>
                          <th scope="col" class="p-2 text-center">Pendentes</th>
                          <th scope="col" class="p-2 text-center" colspan="2">Composição</th>
                        </tr>
                        <tr class="bg-light">
                          <th scope="col" class="p-2"></th>
                          <th scope="col" class="p-2"></th>
                          <th scope="col" class="p-2 text-center" v-if="flagApresentarColunasLote"></th>
                          <th scope="col" class="p-2 text-center" v-if="flagApresentarColunasLote"></th>
                          <th scope="col" class="p-2 text-center"></th>
                          <th scope="col" class="p-2 text-center"></th>
                          <th scope="col" class="p-2 text-center"></th>
                          <th scope="col" class="p-2 text-center">Fator</th>
                          <th scope="col" class="p-2 text-center">Valor</th>
                        </tr>
                        </thead>
                        <tbody>
                        <template v-if="wmsOsItensDataConferidos.length > 0">
                          <template v-for="data in wmsOsItensDataConferidos" :key="data.id">
                            <tr class="border-bottom"> <td class="p-2" style="cursor:pointer;" @click="preencheInputProduto(data.produto)">{{ data.produto }}<span class="text-muted">(EAN:{{ data.codbarra }})</span></td>
                              <td class="p-2">{{ data.descprod }}</td>
                              <td class="p-2" v-if="flagApresentarColunasLote">
                                <table v-if="data.lote && data.lote.length > 0" class="table table-sm mb-0">
                                  <thead>
                                  <tr>
                                    <th>Lote</th>
                                    <th>Qtd</th>
                                  </tr>
                                  </thead>
                                  <tbody>
                                  <tr v-for="(l, index) in data.lote" :key="index">
                                    <td>{{ l.lote }}</td>
                                    <td>{{ l.qtd }}</td>
                                  </tr>
                                  </tbody>
                                </table>
                                <span v-else>-</span>
                              </td>
                              <td class="p-2" v-if="flagApresentarColunasLote">
                                <table v-if="data.endwms && data.endwms.length > 0" class="table table-sm mb-0">
                                  <thead>
                                  <tr>
                                    <th>Lote</th>
                                    <th>Endereço</th>
                                  </tr>
                                  </thead>
                                  <tbody>
                                  <tr v-for="(e, index) in data.endwms" :key="index">
                                    <td>{{ e.lote }}</td>
                                    <td>{{ e.endwms }}</td>
                                  </tr>
                                  </tbody>
                                </table>
                                <span v-else>-</span>
                              </td>
                              <td class="p-2 text-center">{{ formatDecimal(data.qtd) }}</td>
                              <td class="p-2 text-center text-success font-weight-bold"><h4 class="text-success">{{ formatDecimal(data.qtdlida) }}</h4></td>
                              <td class="p-2 text-center text-danger font-weight-bold"><h4 class="text-danger">{{ formatDecimal(data.qtddisp) }}</h4></td>
                              <td class="p-2 text-center">{{ data.composicao ? (data.composicao[0].fator === '/' ? "Divisão" : "Multiplicação") : "-" }}</td>
                              <td class="p-2 text-center">{{ data.composicao ? formatDecimal(data.composicao[0].qtd) : "-" }}</td>
                            </tr>
                          </template>
                        </template>
                        <template v-else>
                          <tr>
                            <td colspan="9"> <b-alert show variant="warning" class="m-0">Nenhum item ainda foi conferido!</b-alert>
                            </td>
                          </tr>
                        </template>
                        </tbody>
                      </table>
                    </div>
                  </b-tab>
                </b-tabs>
              </b-card-body>
        </div>
      </b-card-body>
    </b-card>

    <b-modal size="lg" @shown="$refs.qtdvolume.focus()" title="Identificar Volume(s)" v-model="showModalVolume" centered
      hide-footer>

      <div class="row">

        <div class="col-md-6">
          <div class="mb-3">
            <label for="quantidade">Quantidade</label>
            <input id="qtdvolume" ref="qtdvolume" v-model="wmsOsVolumeData.qtd" type="number"
              class="form-control text-end" @keypress.enter="informouQtdVolume" placeholder="Enter para confirmar..." />
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3">
            <label for="pesovolume">Peso</label>
            <input id="pesovolume" ref="pesovolume" v-model="wmsOsVolumeData.peso" type="number"
              class="form-control text-end" @keypress.enter="informouPeso" placeholder="Enter para confirmar..." />
          </div>
        </div>

      </div>


      <div class="row" v-if="loadingWmsVolume">
        <div class="col-12 text-center">
          <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
          </b-spinner>
          <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
          </b-spinner>
          <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
          </b-spinner>
        </div>
      </div>



      <div class="table-responsive" v-if="wmsOsVolumesData">
        <table class="table table-centered table-nowrap">
          <thead>
            <tr>

              <th scope="col" class="">ID</th>
              <th scope="col" class="">Etiqueta</th>

              <th scope="col" class="text-end">Peso</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="data in wmsOsVolumesData" :key="data.id">

              <td>
                <div>
                  <h5 class="text-truncate font-size-14">
                    {{ data.id }}
                  </h5>
                </div>
              </td>

              <td class="text-info">
                <a href="javascript:void(0);" @click="imprimirEtiqueta(data.id)">
                  <i class="mdi mdi-printer"></i>
                  {{ data.etiqueta }}
                </a>
              </td>


              <td class="text-end">{{ formatDecimal(data.peso) }}</td>
            </tr>

            <tr>
              <td colspan="2">
                <h6 class="m-0 text-end">Quantidade Total Volumes:</h6>
              </td>
              <td class="text-end"> {{ formatDecimal(somaQtdVolumes) }}</td>
            </tr>

            <tr>
              <td colspan="2">
                <h6 class="m-0 font-size-14  text-end">Peso Total Volumes:</h6>
              </td>
              <td class="font-size-14 text-end"> {{ formatDecimal(somaPesoVolumes) }}</td>
            </tr>

          </tbody>
        </table>
      </div>




      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalVolume = false">
          <i class="bx bx-block font-size-16 align-middle me-2"></i>
          Cancelar
        </b-button>

        <b-button type="submit" variant="outline-danger" class="ms-1" v-if="wmsOsVolumesData.length > 0"
          @click="excluirEtiquetas">
          <i class="bx bxs-trash font-size-16 align-middle me-2"></i>
          Excluir Etiquetas
        </b-button>



        <b-button type="submit" variant="success" class="ms-1"
          :disabled="!this.wmsOsVolumeData.qtd || this.wmsOsVolumeData.qtd <= 0 || !this.wmsOsVolumeData.peso || this.wmsOsVolumeData.peso <= 0"
          @click="confirmarVolume">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar Novo Volume
        </b-button>

      </div>
    </b-modal>

    <b-modal title="Associar a Romaneio" v-model="showAssocRoma" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <span>Selecionar Romaneio</span>

          <multiselect id="inputRomaneio" @search-change="pesqRomaneio" v-model="wmsOsData.wmsroma_id"
            placeholder="Pesquisar romaneio" :options="dtListPesqRoma" :searchable="true" label="nome" track-by="nome"
            value-prop="id">
            <template #option="slotProps">
              <div class="row">
                <div>
                  <span class="text-info">
                    {{ slotProps.option.id }}
                  </span>
                  <span class="mx-4">
                    {{ slotProps.option.cnpj }}
                  </span>
                </div>
                <div class="mt-2 font-size-20">{{ slotProps.option.nome }}</div>
                <div class="align-items-end text-end align-content-end">{{ slotProps.option.motorista }}</div>
              </div>
            </template>
          </multiselect>

        </div>

        <div class="text-end mt-5">
          <b-button variant="light" @click="showAssocRoma = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button :disabled="wmsOsData.wmsroma_id === 0" type="submit" variant="success" class="ms-1"
            @click="confirmarAssocRoma()">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>
  </div>
</template>


<style scoped>

.gap-2 > *:not(:first-child) {
  margin-left: 0.5rem;
}

.gap-3 > *:not(:first-child) {
  margin-left: 0.75rem;
}

.table-responsive {
  overflow-x: auto;
}

.table.text-lg th,
.table.text-lg td {
  font-size: 1.125rem;
}

.custom-card-green {
  background-color: #dcfce7;
  color: #14532d;
  border: none;
}

.custom-card-red {
  background-color: #fee2e2;
  color: #7f1d1d;
  border: none;
}

.custom-warning-bg {
    background-color: #fffdc8;
    border: none;
}

[v-cloak] {
  display: none;
}

</style>